import type { GraphNode, NodeKind, ValuePortType, ValueSubtype } from '../graph/nodeDefs.js';
import {
  renderValueNodeUI,
} from './polymorphicValueFieldEditor.js';
import {
  renderColorNodeUI,
  renderFloatValueUI,
  renderVecValueUI,
} from './typedValueFieldEditors.js';

export type NodeFieldCommands = {
  setValueComponent: (nodeId: string, component: 0 | 1 | 2 | 3, value: number) => void;
  setValueExposed: (nodeId: string, exposed: boolean) => void;
  setValueName: (nodeId: string, name: string) => void;
  setValueOutputType: (nodeId: string, valueType: ValuePortType) => void;
  setValueRangeEnabled: (nodeId: string, field: 'min' | 'max', enabled: boolean) => void;
  setValueRangeField: (nodeId: string, field: 'min' | 'max', value: number) => void;
  setValueSubtype: (nodeId: string, subtype: ValueSubtype) => void;
};

export type NodeFieldRenderDeps = {
  scheduleRender: () => void;
  updateParams: () => void;
  setupPortDrag: (dot: HTMLElement) => void;
  renderGraph: () => void;
  commands: NodeFieldCommands;
};

export interface NodeRenderDeps {
  scheduleRender: () => void;
  updateParams: () => void;
  setupPortDrag: (dot: HTMLElement) => void;
  renderGraph: () => void;
  commands: NodeFieldCommands;
}

type NodeUIRenderer = (node: GraphNode, container: HTMLElement, deps: NodeRenderDeps) => void;

const NODE_UI_RENDERERS: Partial<Record<NodeKind, NodeUIRenderer>> = {
  Value: renderValueNodeUI,
  Float: renderFloatValueUI,
  Vector2: renderVecValueUI,
  Vector3: renderVecValueUI,
  Vector4: renderVecValueUI,
  Color: renderColorNodeUI,
};

export function renderCustomNodeUI(node: GraphNode, container: HTMLElement, deps: NodeRenderDeps): boolean {
  const renderer = NODE_UI_RENDERERS[node.type];
  if (!renderer) return false;
  renderer(node, container, deps);
  return true;
}
